import { EditPage, EditPageTextField, EditPagePanel } from './../../../common/EditPage';
import SelectContainer from './../../../common/SelectContainer';
import MultiSelectContainer from './../../../common/MultiSelectContainer';
import { create, getOne } from './../../../common/v4/BackendProvider';
import { showSuccess, showApiError } from './../../../common/utils/toast';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import TextAreaWithPlaceholders from './../../../common/TextAreaWithPlaceholders';
import './tasks.css';

const AiTasksCreate = () => {
    const [data, setData] = useState({ temperature: 0.7, task_type: 'voice', call_direction: 'outbound', input_fields: [] });
    const [metadata, setMetadata] = useState({});
    const [placeholderDisplayMap, setPlaceholderDisplayMap] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        getOne('/admin/ai/tasks/new', '').then(response => {
            setMetadata(response.data.metadata);
            if (response.data.placeholderDisplayMap) {
                setPlaceholderDisplayMap(response.data.placeholderDisplayMap);
            }
        }).catch(error => {
            showApiError(error, 'Error loading task configuration');
        });
    }, []);

    const handleSave = () => {
        create('/admin/ai/tasks', {data: data}).then(response => {
            showSuccess("AI Task created successfully");
            navigate('/ai/tasks');
        }).catch(error => {
            showApiError(error, 'Error creating AI Task');
        });
    }
    const handleCancel = () => {
        navigate('/ai/tasks');
    }
    const onChange = (id, value) => {
        // Rename llm_model_id to model_id for backend
        if (id === 'llm_model_id') {
            setData({ ...data, model_id: value });
            return;
        }

        if (id === 'task_type') {
            if (value === 'voice') {
                setData({ ...data, task_type: value, call_direction: data.call_direction || 'outbound' });
            } else {
                setData({ ...data, task_type: value, call_direction: null, agent_id: null, audio_config_profile_id: null });
            }
            return;
        }

        setData({ ...data, [id]: value });
    }

    // Convert contact_fields object to options array for MultiSelectContainer
    const getContactFieldOptions = () => {
        if (!metadata?.contact_fields) return [];
        return Object.entries(metadata.contact_fields).map(([value, label]) => ({
            value,
            label
        }));
    };
    
    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                style={{ zIndex: 9999 }}
                closeButton={true}
                rtl={false}
                newestOnTop={false}
                pauseOnFocusLoss={true}
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create AI Task" >
                <EditPagePanel className="col-lg-6">
                    <EditPageTextField inputGroupClassName="col-sm-12"  label="Name" id="name" onChange={ onChange } value={ data.name } />
                    <EditPageTextField  inputGroupClassName="col-sm-12" label="Description" id="description" onChange={ onChange } value={ data.description } />
                    <SelectContainer 
                        label="Task Type" 
                        id="task_type" 
                        onChange={ onChange } 
                        value={ data.task_type } 
                        options={ [
                            { value: 'voice', label: 'Voice (Phone Calls)' },
                            { value: 'text', label: 'Text (Chat/Messaging)' }
                        ] } 
                    />
                </EditPagePanel>
                 <EditPagePanel className="col-lg-6">
                    {data.task_type === 'voice' && (
                        <>
                            <SelectContainer label="Agent" id="agent_id" onChange={ onChange } value={ data.agent_id } options={ metadata?.agents } />
                            <SelectContainer label="Audio Config Profile" id="audio_config_profile_id" onChange={ onChange } value={ data.audio_config_profile_id } options={ metadata?.audio_config_profiles } />
                            <SelectContainer 
                                label="Call Direction" 
                                id="call_direction" 
                                onChange={ onChange } 
                                value={ data.call_direction } 
                                options={ [
                                    { value: 'outbound', label: 'Outbound (Agent initiates call)' },
                                    { value: 'inbound', label: 'Inbound (Contact calls in)' }
                                ] } 
                            />
                        </>
                    )}
                    <SelectContainer label="Client" id="client_id" onChange={ onChange } value={ data.client_id } options={ metadata?.clients } />
                    <SelectContainer label="LLM Model" id="llm_model_id" onChange={ onChange } value={ data.llm_model_id } options={ metadata?.llm_models } />
                    <EditPageTextField label="Temperature" id="temperature" onChange={ onChange } value={ data.temperature } placeholder="0.0 - 2.0" />
                    {data.task_type === 'text' && (
                        <MultiSelectContainer 
                            label="Input Fields (from Contact Fields)" 
                            id="input_fields" 
                            onChange={ onChange } 
                            value={ data.input_fields || [] } 
                            options={ getContactFieldOptions() }
                            placeholder="Select contact fields to use as inputs"
                        />
                    )}
                </EditPagePanel>
                
                <EditPagePanel className="col-lg-12">
                    <TextAreaWithPlaceholders
                        inputGroupClassName="col-sm-12" 
                        label="Opening Instructions (for inbound calls)" 
                        id="opening_instructions" 
                        onChange={ onChange } 
                        value={ data.opening_instructions } 
                        rows={ 40 }
                        placeholderDisplayMap={placeholderDisplayMap}
                    />
                </EditPagePanel>
                <EditPagePanel className="col-lg-12">
                    <TextAreaWithPlaceholders 
                        inputGroupClassName="col-sm-12" 
                        label="Instructions" 
                        id="instructions" 
                        onChange={ onChange } 
                        value={ data.instructions } 
                        rows={ 40 }
                        placeholderDisplayMap={placeholderDisplayMap}
                    />
                </EditPagePanel> 
            </EditPage>
        </div>
    );
};

export default AiTasksCreate;